import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';

const ERROR_MESSAGES = {
	ELEMENT_NOT_FOUND: 'Dropdowns: No dropdown elements found',
	INIT_FAILED: 'Dropdowns: Initialization failed',
	TOGGLE_FAILED: 'Dropdowns: Failed to toggle dropdown',
};

const CONFIG = {
	SELECTORS: {
		DROPDOWN_ITEMS: '.nav-item.dropdown',
		DROPDOWN_TOGGLE: '.dropdown-toggle',
		NAV_ITEMS: '.nav-item',
		DROPDOWN_MENU: '.dropdown-menu',
	},
};

/**
 * Initialize dropdown menu functionality
 * @returns {void}
 */
const initializeDropdowns = () => {
	try {
		const dropdownElements = document.querySelectorAll(CONFIG.SELECTORS.DROPDOWN_ITEMS);
		const navItems = document.querySelectorAll(CONFIG.SELECTORS.NAV_ITEMS);

		if (!dropdownElements.length) {
			console.warn(ERROR_MESSAGES.ELEMENT_NOT_FOUND);
			return;
		}

		/**
		 * Close all dropdowns
		 * @returns {void}
		 */
		const closeAllDropdowns = () => {
			try {
				dropdownElements.forEach((dropdown) => {
					const toggle = dropdown.querySelector(CONFIG.SELECTORS.DROPDOWN_TOGGLE);
					if (toggle) {
						const dropdownMenu = new bootstrap.Dropdown(toggle);
						dropdownMenu.hide();
					}
				});
			} catch (error) {
				console.error(ERROR_MESSAGES.TOGGLE_FAILED, error);
			}
		};

		navItems.forEach((navItem) => {
			navItem.addEventListener('mouseenter', () => {
				closeAllDropdowns();
			});
		});

		dropdownElements.forEach((dropdown) => {
			const dropdownMenu = dropdown.querySelector(CONFIG.SELECTORS.DROPDOWN_MENU);

			dropdown.addEventListener('mouseenter', () => {
				try {
					const toggle = dropdown.querySelector(CONFIG.SELECTORS.DROPDOWN_TOGGLE);
					if (toggle) {
						const dropdownMenu = new bootstrap.Dropdown(toggle);
						dropdownMenu.show();
					}
				} catch (error) {
					console.error(ERROR_MESSAGES.TOGGLE_FAILED, error);
				}
			});

			if (dropdownMenu) {
				dropdownMenu.addEventListener('mouseleave', () => {
					closeAllDropdowns();
				});
			}
		});
	} catch (error) {
		console.error(ERROR_MESSAGES.INIT_FAILED, error);
	}
};

export { initializeDropdowns };
